module.exports = __webpack_public_path__ + "an.no2.b98b98a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/an.no2.jpg
// module id = vO3V
// module chunks = 0